/**
 * Is a template section usable for this account? A regular section is, unless
 * the account switched it off; a `custom` (niche, optional) section is not,
 * until the account switched it on under Settings → Account → Sections. The
 * switch is the setting `section:<key>:visibility`. The page area picker, the
 * section toggles and the global-content picker all ask here, so an optional
 * section cannot appear through one of them while hidden in another.
 */
export const sectionIsVisible = (section, settingValues = {}) => {
    if (!section) return false;

    let visible = section.custom == null || section.custom === false;

    const value = settingValues[`section:${section.key}:visibility`];
    if (value !== undefined) {
        visible = ['true', '1', 'yes', true].includes(value);
    }

    return visible;
};
